<div class="xp-password-strength__header">{{ header() }}</div>
<mat-progress-bar class="xp-password-strength__bar"
                  mode="determinate"
                  [value]="progress()"></mat-progress-bar>
<div class="xp-password-strength__score">{{ scoreLabel() }}</div>
<span class="xp-password-strength__divider"></span>
<div class="xp-password-strength__suggestions">Suggestions</div>
<ul class="xp-password-strength__rules">
	<li *ngFor="let rule of rules()"
	    class="xp-password-strength__rule"
	    [class.xp-password-strength__rule--met]="rule.met">{{ rule.label }}</li>
</ul>
